// ─────────────────────────────────────────────
//  PendingAlerts.js — Dashboard alerts snapshot
// ─────────────────────────────────────────────
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAlerts } from "../../hooks/useAlerts";
import "./PendingAlerts.css";

export default function PendingAlerts() {
  const { alerts, loading } = useAlerts();
  const navigate = useNavigate();

  const top5 = alerts.slice(0, 5);

  return (
    <div className="pa-wrap">
      <div className="pa-header">
        <span className="pa-title">Pending Alerts</span>
        {alerts.length > 0 && (
          <span className="pa-badge">{alerts.length}</span>
        )}
        <button className="pa-link" onClick={() => navigate("/alerts")}>
          Manage →
        </button>
      </div>

      {loading ? (
        <div className="pa-rows">
          {Array.from({ length: 3 }).map((_, i) => (
            <div className="pa-skel-row" key={i}>
              <div className="pa-skel w50" />
              <div className="pa-skel w30" />
            </div>
          ))}
        </div>
      ) : top5.length === 0 ? (
        <div className="pa-empty">
          <div className="pa-empty-icon">🔔</div>
          <p>No active alerts</p>
          <button className="pa-add-btn" onClick={() => navigate("/alerts")}>
            Create Alert →
          </button>
        </div>
      ) : (
        <div className="pa-rows">
          {top5.map((alert) => {
            const isTarget = alert.alert_type === "TARGET";
            return (
              <div className="pa-row" key={alert.id}>
                <div className="pa-row-left">
                  <span className={`pa-type-dot ${isTarget ? "target" : "stoploss"}`} />
                  <div>
                    <span className="pa-sym">{alert.symbol}</span>
                    <span className="pa-type">{isTarget ? "Target" : "Stop Loss"}</span>
                  </div>
                </div>
                <div className="pa-row-right">
                  <span className="pa-trigger">
                    ₹{Number(alert.trigger_price).toLocaleString("en-IN", { maximumFractionDigits: 2 })}
                  </span>
                  <span className={`pa-pill ${isTarget ? "target" : "stoploss"}`}>
                    {isTarget ? "▲ Target" : "▼ SL"}
                  </span>
                </div>
              </div>
            );
          })}
          {alerts.length > 5 && (
            <div className="pa-more" onClick={() => navigate("/alerts")}>
              +{alerts.length - 5} more alerts →
            </div>
          )}
        </div>
      )}
    </div>
  );
}
